module.exports = __webpack_public_path__ + "img/icon-oddchange-up.087dd61b.svg";